import React, { useState } from "react";

import { generateRandomId, useTranslation } from "utils";

import { ExtraInfo, Form, Icon, InputNumber } from "components";

export const PesticidesForm = ({ forms, index, pesticide, year, onUpdate, showErrors = true }) => {
  const { t } = useTranslation(["modules"]);
  const [showExplainerDrawer, setShowExplainerDrawer] = useState(false);

  const rules = [{ required: true, message: false }];

  return (
    <>
      <div className="form-product">
        <div className="form-product-header">
          <div className="icon-row margin-bottom-0">
            <h6>{t("bauEntryDrawer.pesticides.product", { number: index + 1 })}</h6>
            <Icon
              iconName="tabler/info-circle"
              size="s"
              className="inline margin-left-25"
              onClick={() => setShowExplainerDrawer(true)}
              mixpanelText={t("bauEntryDrawer.pesticides.product")}
            />
          </div>
        </div>
        <Form
          name={year ? `existing-${year}-${index}-${generateRandomId()}` : `existing-${index}-${generateRandomId()}`}
          ref={year ? (el) => (forms.current[year][index] = el) : (el) => (forms.current[index] = el)}
          onValuesChange={(_, v) => onUpdate(index, v)}
          className={!showErrors ? "no-errors" : ""}
        >
          <div className="form-input-container">
            <div>
              <InputNumber
                dataTestId={`pesticides-form-total-amount-input-${year}`}
                label={t("bauEntryDrawer.pesticides.activeIngredient")}
                name="activeIngredient"
                decimalSeparator=","
                initialValue={pesticide.activeIngredient}
                min={0}
                rules={rules}
                step={0.01}
                suffix={t("bauEntryDrawer.pesticides.activeIngredientSuffix")}
                required
              />
            </div>
          </div>
        </Form>
      </div>
      <ExtraInfo type="pesticides-explainer" visible={showExplainerDrawer} setVisible={setShowExplainerDrawer} />
    </>
  );
};
